import { reducerRegistry } from '../../../../reducerRegistry';

import collectionsReducersMap from './collections/reducersMap';

const combineMap = {
  collections: collectionsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('infoMaterialsModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/infoMaterials/reducers/static/combineRegistry.js